module.exports = __webpack_public_path__ + "static/media/stand_up_comedians.62a2c147.webp";